import { useContentSelectors } from "../../../../../../../store/content/content.selectors";

import { DropDown } from "../../../../../../../components/ui/DropDown/DropDown";

const CountriesDropDown = ({ closeSelect, selectId, top, topMobile, left }) => {
  const { allCountry } = useContentSelectors();

  return (
    <DropDown
      search={true}
      options={allCountry}
      closeSelect={closeSelect}
      selectId={selectId}
      top={top}
      topMobile={topMobile}
      left={left}
    />
  );
};

export default CountriesDropDown;
